module.exports = __webpack_public_path__ + "img/lg_no_ring@3x.8ed0fcca.png";